<template>
  <section class="bg-white pt-5 pb-5" v-if="categories.length">
    <div class="container">
      <div class="section-title mb-2">
        <h2>{{ translations.highlightedCategories }}</h2>
      </div>
      <div class="row row-sm">
        <div class="col-lg-6" v-for="item in categories" :key="item.id">
          <a :href="item.contentUrl">
            <div class="banner-product">
              <img :src="`${baseUrl}${item.imageUrl}`" />
              <div class="banner-product-description">
                <!--<h2>ACTION <br>CAMERAS</h2>-->
                <div class="ml-3 primary-background">
                  <h3 class="skew-box">{{ item.contentTitle }}</h3>
                  <h4 class="skew-box">
                    <span class="product-price" v-if="item.mainDescription">
                      {{ item.mainDescription }}
                    </span>
                    <span class="old-price" v-if="item.secondaryDescription">
                      {{ item.secondaryDescription }}
                    </span>
                  </h4>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import config from '@/config';
import { translations } from '@/mixins';

export default {
  name: 'HighlightedCategories',
  mixins: [translations],
  computed: {
    categories() {
      return this.$store.getters.getHighlightedCategories;
    },
    baseUrl() {
      return config.baseUrl;
    },
  },
  mounted() {
    this.$store.dispatch('getHighlightedCategories');
  },
};
</script>
<style scoped>
.skew-box{
  transform: skew(0deg, 0deg);
}
</style>
